<template>
  <div
    v-if="loadingModal"
    class="loading-modal d-flex justify-content-center"
    @click.self="closeLoadingModal"
  >
    <div class="gif-modal">
      <div class="inner-bg">
        <div v-if="claimedList.length > 0">
          <div class="d-flex flex-row justify-content-center top-of-modal">
            {{
              claimedList[claimedIndex].topOfModal
                ? claimedList[claimedIndex].topOfModal
                : "&nbsp;"
            }}
          </div>
          <div
            class="d-flex flex-row justify-content-center center-of-modal mt-2"
          >
            <div class="d-flex align-items-center ml-md-3 ios-phone-left">
              <button @click="goPreviousIndex()">&lt;</button>
            </div>
            <img
              width="275px"
              height="270px"
              :src="getImageUrl(claimedList[claimedIndex].whichGifToPlay)"
              alt=""
            />
            <div class="d-flex align-items-center mr-md-3 ios-phone-right">
              <button @click="goNextIndex()">&gt;</button>
            </div>
          </div>
          <div
            class="
              d-flex
              flex-row
              justify-content-center
              text-center
              bottom-of-modal
              windows-command-prompt
              text-capitalize
            "
          >
            {{ claimedList[claimedIndex].bottomOfModal }}
          </div>
        </div>
        <div v-else>
          <div class="d-flex flex-row justify-content-center top-of-modal">
            {{ topOfModal ? topOfModal : "&nbsp;" }}
          </div>
          <div
            class="d-flex flex-row justify-content-center center-of-modal mt-2"
          >
            <img
              width="275px"
              height="270px"
              :src="getImageUrl(whichGifToPlay)"
              alt=""
            />
          </div>
          <div
            class="
              d-flex
              flex-row
              justify-content-center
              text-center
              align-items-center
              bottom-of-modal
              windows-command-prompt
            "
          >
            {{bottomOfModal}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "loading-gifs-modal",
  props: {
    loadingModal: {
      default: false,
      type: Boolean,
    },
    topOfModal: {
      default: "Loading",
      type: String,
    },
    bottomOfModal: {
      default: "Loading",
      type: String,
    },
    whichGifToPlay: {
      default: "images/gifs/chicken-fall-failed.gif",
      type: String,
    },
    claimedList: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      claimedIndex: 0,
    };
  },
  methods: {
    getImageUrl(pic) {
      return require("../assets/" + pic);
    },
    closeLoadingModal() {
      this.$emit("loadingModal", false);
    },
    goNextIndex() {
      if (this.claimedIndex < this.claimedList.length - 1) {
        this.claimedIndex = this.claimedIndex + 1;
      }
    },
    goPreviousIndex() {
      if (this.claimedList.length > 1 && this.claimedIndex > 0) {
        this.claimedIndex = this.claimedIndex - 1;
      }
    },
  },
};
</script>

<style scoped>
.loading-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1055;
  display: block;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  background: rgba(0, 0, 0, .6);
}
.top-of-modal {
  font-size: 40px;
  color: #ffe371;
}
.center-of-modal button {
  background: none;
  border: none;
  font-size: 40px;
  color: #ffe371;
}
.bottom-of-modal {
  font-size: 18px;
  color: white;
  width: 100%;
  min-height: 60px;
}
.gif-modal {
  width: 501px;
  height: 506px;
  margin: 20px;
  padding: 50px 0;
  top: 20%;
  position: relative;
  background-image: url("../assets/images/loading-border.webp");
}
.inner-bg{
  position: absolute;
  background-color: #000016;
  height: 404px;
  width: 404px;
  right: 0;
  left: 0;
  margin: auto;
  padding: 10px;
}
@media (max-width: 1300px) {
  .bottom-of-modal {
    font-size: 15px;
  }
}
@media (max-width: 700px) {
  .gif-modal {
    width: 300px;
    height: 300px;
    background-size: 300px 300px;
    padding: 20px 0;
  }
  .inner-bg{
    width: 250px;
    height: 250px;
  }
  .center-of-modal img {
    width: 150px;
    height: 150px;
  }
  .top-of-modal {
    font-size: 25px;
  }
  .bottom-of-modal {
    font-size: 10px;
    min-height: 40px;
  }
  @supports (-webkit-touch-callout: none) {
    .ios-phone-left {
      margin-right: -20px;
    }
    .ios-phone-right {
      margin-left: -20px;
    }
  }
}
</style>